/**
 * 
 * Whenever this element is rendered, it issues a "silent" request to the specified url
 * This element contains the following attributes:
 * 
 * - method: specifies the HTTP method when issuing the ajax request. It is optional. Default value is GET
 * - url: this attribute is required and specifies the url of the ajax request
 * 
 * Cross-domain requests are not allowed/implemented. 
 * Also, POSTing data is not implemented either
 * Because requests are silent, not callbacks are supported so far
 * 
 * Example
 * <request method='POST' url='/updates/1245/read' />
 * 
 * */

$(function () {
    document.createElement("request");

    $("request").each(function () {
        var method = $(this).attr("method");
        var url = $(this).attr("url");
        var token = $(this).attr("csrf-token");
        var data = null;

        method = method || "GET";

        if (url) {
            if (token) {
                data = { __RequestVerificationToken: token };
            }

            $.ajax({
                url: url,
                method: method,
                data: data,
                traditional: true
            });
        }
    });
});